import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

//import { theme } from '@ecp/common/src/style/theme/default';
import boTheme from '@ecp/common/src/style/theme/bo';
import { FlexBox, FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import { inputClassNames } from '@ecp/common/src/components/unstyled/input/InputUnstyled';
import { ReactComponent as SearchSvg } from '@ecp/common/src/assets/icon/icon__search--grey.svg';
import { ReactComponent as InitializationSvg } from '@ecp/common/src/assets/icon/icon__initialization.svg';

import Input, { inputBasePropTypes } from './Input';

const defaultStyle = css`
  height: 28px;
  width: 100%;
  background-color: ${(props) => props.theme.color.background.white};
  border: 1px solid ${boTheme.color.sub6};
  border-radius: 3px;
  padding: 7px 8px;
  box-sizing: border-box;
`;

const StyledSearchInputRoot = styled(FlexBoxSpaceBetween)`
  ${({ type }) => (type === 'default' ? defaultStyle : '')}

  & input {
    font-weight: ${boTheme.font.weight.regular};
    font-size: ${boTheme.font.size.small};
    line-height: 13px;
  }

  &.${inputClassNames.readOnly} {
    background-color: ${boTheme.color.sub8};
  }
`;

const StyledInputInitialization = styled(FlexBoxSpaceBetween)`
  cursor: pointer;
  flex: 0 0 52px;
  font-size: ${(props) => props.theme.font.size.small};
  user-select: none;
`;

const SearchInput = React.forwardRef(
  ({ enableInitialize, endAdornment, type, onSearchClick, onInitializeClick, ...props }, ref) => {
    return (
      <FlexBox gap="20px" width="fit-content" flex={'1'}>
        <Input
          searchClear
          {...props}
          ref={ref}
          rootProps={{ type }}
          rootComponent={StyledSearchInputRoot}
          endAdornment={
            <>
              <SearchIcon onClick={onSearchClick} />
              {endAdornment}
            </>
          }
        />
        {enableInitialize && (
          <StyledInputInitialization onClick={onInitializeClick}>
            <InitializationSvg width={10} height={13} />
          </StyledInputInitialization>
        )}
      </FlexBox>
    );
  }
);

SearchInput.propTypes = {
  type: PropTypes.oneOf(['default']),
  enableInitialize: PropTypes.bool,
  onSearchClick: PropTypes.func,
  onInitializeClick: PropTypes.func,
  ...inputBasePropTypes,
};

SearchInput.defaultProps = {
  type: 'default',
  enableInitialize: false,
};

SearchInput.displayName = 'SearchInput';

export default SearchInput;

const SearchIcon = styled(SearchSvg)`
  cursor: pointer;
  width: 14px;
  height: 14px;
`;
